const firebaseConfig = {
    // apiKey: process.env.REACT_APP_API_KEY,
    // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_APP_ID,
    apiKey: "AIzaSyAHMBi2O5g-b7j9ufc3vVdLjfISm8q6h0Y",
    authDomain: "goriber-gari-website.firebaseapp.com",
    projectId: "goriber-gari-website",
    storageBucket: "goriber-gari-website.appspot.com",
    messagingSenderId: "1026357601735",
    appId: "1:1026357601735:web:6f67bab34865a405aa25e2"
};
export default firebaseConfig;